import React, { useEffect, useState } from 'react';
import axios from 'axios';

import CardTeam from '../../../components/TeamCard/CardTeam';
import CardTeamWrapper from '../../../components/TeamCard/CardTeamWrapper';
import Spinner from 'components/Spinner/Spinner';

import teamPic from '../../../assets/FullTeam.png';

export default function Personale() {
  const [isLoading, setIsLoading] = useState(true);
  const [team, setTeam] = useState();

  async function getEmployees() {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}employees?per_page=100`
      );
      setTeam(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
    getEmployees();
  }, []);
  return (
    <>
      <div className="w-full bg-gray-800">
        <div className="container mx-auto">
          <img src={teamPic} alt="team" />
        </div>
        <div className="container px-10 mx-auto">
          <CardTeamWrapper title="Soci">
            {isLoading && (
              <div className="flex items-center justify-center">
                <Spinner className="w-16 h-16 text-white" />
              </div>
            )}
            {!isLoading &&
              team &&
              team
                .filter((item) => item.acf.categoria === 'Socio')
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((item) => (
                  <CardTeam member={item.acf} idx={item.acf.nome_completo} />
                ))}
          </CardTeamWrapper>
          <CardTeamWrapper title="Dipendenti">
            {isLoading && (
              <div className="flex items-center justify-center">
                <Spinner className="w-16 h-16 text-white" />
              </div>
            )}
            {!isLoading &&
              team &&
              team
                .filter((item) => item.acf.categoria === 'Dipendente')
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((item) => (
                  <CardTeam member={item.acf} idx={item.acf.nome_completo} />
                ))}
          </CardTeamWrapper>
        </div>
      </div>
    </>
  );
}
